import instanciaAxios from './InterceptorAxios';


const servicioMenu = {
	buscarMenu() {
		return instanciaAxios.post("/menu/crearMenu.json");
	}
}

export default servicioMenu;